import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=0ade1279&scoped=true&"
import script from "./Action.js?vue&type=script&lang=js&"
export * from "./Action.js?vue&type=script&lang=js&"
import style0 from "./Action.scss?vue&type=style&index=0&id=0ade1279&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ade1279",
  null
  
)

export default component.exports